import _Row from "antd/es/row";
import _Col from "antd/es/col";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _Form from "antd/es/form";
import _Radio from "antd/es/radio";
import React, { Component } from 'react';
import { css } from 'emotion';
import sanitize from 'sanitize-html';
import { getLocalText } from '@/utilities/language';
import SingleChoice from '../../common/Question/SingleChoice';
import InputSingleLine from './InputSingleLine';
import MaterialSingleSelect from './MaterialUI/SingleSelect';
var RadioGroup = _Radio.Group;
var FormItem = _Form.Item;
var SingleChoicePC = /*#__PURE__*/function (_Component) {
  _inherits(SingleChoicePC, _Component);
  function SingleChoicePC() {
    _classCallCheck(this, SingleChoicePC);
    return _possibleConstructorReturn(this, _getPrototypeOf(SingleChoicePC).apply(this, arguments));
  }
  _createClass(SingleChoicePC, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        question = _this$props.question,
        label = _this$props.label,
        displayType = _this$props.displayType;
      return React.createElement(SingleChoice, this.props, function (_ref) {
        var _formAnswer$selected;
        var _ref$options = _ref.options,
          options = _ref$options === void 0 ? [] : _ref$options,
          formAnswer = _ref.formAnswer,
          error = _ref.error,
          _onChange = _ref.onChange,
          _ref$disabledOptIds = _ref.disabledOptIds,
          disabledOptIds = _ref$disabledOptIds === void 0 ? [] : _ref$disabledOptIds;
        var selected = error.selected,
          text = error.text;
        var _question$custom = question.custom,
          _question$custom$spli = _question$custom.splitCols,
          splitCols = _question$custom$spli === void 0 ? 1 : _question$custom$spli,
          other = _question$custom.other,
          required = question.required,
          id = question.id;
        var rowCounts = Math.ceil(options.length / splitCols); // default to options.length
        var colsSpan = Math.ceil(24 / splitCols); // default to 24
        return React.createElement(FormItem, {
          label: label,
          required: required,
          validateStatus: selected || text ? 'error' : null,
          hasFeedback: true,
          help: selected || text
        }, /select/i.test(displayType) ? React.createElement(MaterialSingleSelect, {
          options: options,
          formAnswer: formAnswer,
          onChange: _onChange,
          disabledOptIds: disabledOptIds
        }) : React.createElement(RadioGroup, {
          onChange: function onChange(e) {
            return _onChange.selected(e.target.value);
          },
          value: (_formAnswer$selected = formAnswer.selected) === null || _formAnswer$selected === void 0 ? void 0 : _formAnswer$selected[0],
          className: "allWidth"
        }, new Array(rowCounts).fill('').map(function (_, i) {
          return React.createElement(_Row, {
            gutter: 16,
            className: wrapperCol,
            key: id.concat(i)
          }, options.slice(i * splitCols, splitCols * (i + 1)).map(function (option) {
            return React.createElement(_Col, {
              span: colsSpan,
              key: option.id
            }, React.createElement(_Radio, {
              key: option.id,
              className: radioCls,
              value: option.id,
              disabled: disabledOptIds.find(function (id) {
                return id === option.id;
              })
            }, optionContentRender({
              option: option,
              error: error,
              formAnswer: formAnswer,
              onChange: _onChange
            })));
          }));
        }), other.status > 0 && React.createElement(_Col, {
          span: colsSpan,
          className: wrapperCol
        }, React.createElement(_Radio, {
          key: "other",
          className: radioCls,
          value: "other"
        }, React.createElement("div", {
          className: error.errorOption === 'other' ? 'option-error' : ''
        }, getLocalText('placeholder.other'), React.createElement(InputSingleLine, {
          placeholder: other.placeholder || '',
          onChange: function onChange(e) {
            return _onChange.text(e.target.value);
          },
          value: formAnswer.text,
          chosen: formAnswer.selected.includes('other'),
          required: other.status === 2,
          id: "other".concat(id.replace('$', ''))
        }))))));
      });
    }
  }]);
  return SingleChoicePC;
}(Component);
export { SingleChoicePC as default };
var wrapperCol = /*#__PURE__*/css("margin-top:26px;&:first-of-type{margin-top:0;}");
var radioCls = /*#__PURE__*/css("display:flex !important;margin-top:26px;&:first-of-type{margin-top:0;}span:not(.ant-radio){width:100%;}.ant-input{border-color:var(--border-gray);}.option-error .ant-input{border-color:var(--text-red);}span.ant-radio + *{white-space:pre-wrap;display:inline-block;margin-top:-3px;padding-left:16px;}&.ant-radio-wrapper-checked{color:var(--primary-color);}");
export function optionContentRender(_ref2) {
  var option = _ref2.option,
    error = _ref2.error,
    _onChange2 = _ref2.onChange,
    formAnswer = _ref2.formAnswer;
  var chosen = formAnswer.selected.includes(option.id);
  var restrictions = (window.showMultiLang ? option === null || option === void 0 ? void 0 : option["".concat(window.language, "Restrictions")] : option.restrictions) || {};
  var maxWords = restrictions.maxWords,
    openWordsRestriction = restrictions.openWordsRestriction;
  return React.createElement("div", {
    className: error.errorOption === option.id ? 'option-error allWidth' : 'allWidth'
  }, React.createElement("div", {
    className: "optionText allWidth"
  }, React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: sanitize(window.showMultiLang ? option === null || option === void 0 ? void 0 : option["".concat(window.language, "Text")] : option.text)
    },
    style: {
      overflow: 'hidden',
      display: 'flex',
      minWidth: 'fit-content',
      width: '100%',
      flexFlow: 'row wrap'
    }
  }), !!option.input && chosen && React.createElement(InputSingleLine, {
    onChange: function onChange(e) {
      return _onChange2.input(option.id, e.target.value);
    },
    value: ((formAnswer.option_blank || {})[option.id] || [])[0] || '',
    placeholder: restrictions.tips || '',
    required: option.input === 'required',
    maxwords: openWordsRestriction ? maxWords : -1,
    chosen: chosen,
    id: "other".concat(option.id)
  })), !window.showMultiLang && option.description && React.createElement("div", {
    className: "description"
  }, option.description), window.showMultiLang && (option === null || option === void 0 ? void 0 : option["".concat(window.language, "Description")]) && React.createElement("div", {
    className: "description"
  }, option === null || option === void 0 ? void 0 : option["".concat(window.language, "Description")]), option.img && React.createElement("img", {
    src: option.img,
    alt: "",
    style: {
      zoom: option.scale || 1,
      marginTop: 10,
      marginBottom: 10
    },
    loading: "lazy"
  }), option.audio && React.createElement("audio", {
    src: option.audio,
    controls: true
  }), option.video && React.createElement("video", {
    src: option.video,
    controls: true
  }));
}